import { handleRetrieveAllSpecialists } from "../../../../redux/member-slices/bookedSpecialists.slice"
import TablePagination from "../../../../components/common/TablePagination"
import { useChatInitiate } from "../../../../hooks/useChatInitiate"
import TableSkell from "../../../../components/common/TableSkell"
import Availability from "../../../../components/ui/availability"
import InputFieldB from "../../../../components/ui/InputFieldB"
import { useDispatch, useSelector } from "react-redux"
import { debounce } from "../../../../utils/helper"
import { useEffect, useRef, useState } from "react"
import Icons from "../../../../assets/js/Icons"
import { NavLink } from "react-router-dom"
import { specialistHeaders } from "./data"

import {
  Avatar, Box, IconButton, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography, Tooltip,
} from "@mui/material"


function Specialist() {
  const dispatch = useDispatch()
  const searchRef = useRef(null)
  const [data, setData] = useState({})
  const { initiateGeneralChat } = useChatInitiate()
  const { loadings } = useSelector((state) => state.otherSlice)

  const { subscription, plan, features } = useSelector(
    (state) => state.subscriptionSlice
  );

  const isSubscribed = Boolean(
    subscription?.hasSubscription ||
    (plan?.name && plan?.name !== "basic") ||
    features?.includes("CHAT_ACCESS_LIMITED") ||
    features?.includes("CHAT_ACCESS_UNLIMITED")
  );

  // --------------- Get all members ---------------
  const handleRetrieveAll = async (filters) => {
    const query = {
      limit: 10,
      currentPage: filters?.currentPage || 1,
      search: searchRef?.current?.value || null,
    }

    const response = await dispatch(
      handleRetrieveAllSpecialists(query)
    ).unwrap() || {}
    if (response?.specialists)
      setData(response)
  }

  // --------------- Handle search ---------------
  const handleSearchChange = debounce(() => {
    // handleRetrieveAll()
  }, 1000)

  // --------------- Handle chat initiate ---------------
  const handleChatInitiate = async (receiver) => {
    initiateGeneralChat(receiver)
  }


  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Box py={5}>
        <Box maxWidth={300}>
          <InputFieldB
            type="text"
            name="search"
            variant="outlined"
            inputRef={searchRef}
            placeholder="Search..."
            onChange={handleSearchChange}
          />
        </Box>
      </Box>

      <Paper variant="contentListing">
        <TableContainer variant="tableViewA">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {specialistHeaders?.map((element, i) => (
                  <TableCell key={i} align="left">{element}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loadings?.retrieveAll ? (
                <TableSkell colLength={specialistHeaders?.length} />
              ) : (
                data?.specialists?.map((element, i) => (
                  <TableRow
                    key={i}
                    sx={{ td: { borderBottomWidth: i === data?.specialists?.length - 1 ? "0" : "1px" } }}
                  >
                    <TableCell>
                      <Avatar sx={{ height: 35, width: 35 }} src={element?.image} />
                    </TableCell>
                    <TableCell sx={{ textTransform: "capitalize" }}>{element?.name}</TableCell>
                    <TableCell>{element?.experience || 0} Year(s)</TableCell>
                    <TableCell>{element?.specializations?.name || "N/A"}</TableCell>
                    <TableCell>{element?.age || "N/A"} {Boolean(element?.age) && "Year(s)"}</TableCell>
                    <TableCell>{element?.appointmentsCount || 0}</TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        color="info"
                        title="View Profile"
                        LinkComponent={NavLink}
                        sx={{ p: 0.25, fontSize: 20, mr: 0.5 }}
                        to={`/member/profile/specialist/${element?.specialistId}`}
                      ><Icons.ViewStrokeStandard />
                      </IconButton>

                      <Tooltip title={!isSubscribed ? "Subscription plan required to chat with specialists" : "Start chat"}>
                        <span>
                          <IconButton
                            size="small"
                            color="info"
                            disabled={!isSubscribed}
                            sx={{ p: 0.25, fontSize: 20 }}
                            onClick={() => { handleChatInitiate(element?.specialistId) }}
                          >
                            <Icons.ChatStrokeRounded />
                          </IconButton>
                        </span>
                      </Tooltip>

                      <Availability
                        trigger={
                          <IconButton color="primary" size="small" sx={{ ml: 0.5 }}>
                            <Icons.Alert />
                          </IconButton>
                        }
                        availability={element?.availability}
                      />
                    </TableCell>
                  </TableRow>
                ))
              )}

              {!data?.specialists?.length && !loadings?.retrieveAll && (
                <TableRow sx={{ td: { borderBottom: "none" } }}>
                  <TableCell colSpan={specialistHeaders?.length}>
                    <Typography variant="noRecords">No results found!</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          mt={0.001}
          color="primary"
          cb={handleRetrieveAll}
          pagination={data?.pagination}
          loading={loadings?.retrieveAll}
          length={data?.specialists?.length}
        />
      </Paper>
    </>
  )
}

export default Specialist